import gql from 'graphql-tag';
import apollo from 'src/features/apolloSecure';

const mutation = gql`
mutation teams($model: TeamInput!) {
  createTeam(team: $model){
    id
    name
    description
    visibleCasesCount
    overseers {
      id
      fullName
    }
    operators {
      id
      fullName
    }
    requestTypePriorities {
      channel {
        id
      }
      requestType {
        id
      }
    }
  }
}`;

function createTeam(model) {
  return apollo.client.mutate({
    mutation,
    variables: {
      model,
    },
  }).then((res) => res.data.createTeam);
}

export default createTeam;
